declare var globalAppSettings: any;
declare var Base64: any;

var Metrics = window.Metrics = (function () {
    const selectors = {
        content: "#page-content",
        scrollarea: "#m-page-content-scrollbar-scrollarea",
        pageContent: "#page-content",
        pageFaq: ".article.page-content__overlay",
        pageNews: ".news-body",
        pageReview: ".review-page",
    };
    const logTypes = {
        scroll: "uni:page-scroll",
        transition: "uni:page-transition",
        reviewAdding: "uni:review-coef-added",
        reviewWidgetAdding: "uni:review-widget-coef-added",
    };

    function getScrollPercent() {
        const documentScrolled = $(selectors.scrollarea).scrollTop();
        const contentHeight = $(selectors.content).height(); // only content without header and footer
        const scrollAreaHeight = $(selectors.scrollarea).height(); // content and footer
        let scrolledPercent = Math.floor(documentScrolled / (contentHeight - scrollAreaHeight) * 100);

        if (scrolledPercent > 100 || contentHeight < scrollAreaHeight) {
            scrolledPercent = 100;
        }

        return scrolledPercent;
    }

    function sendMetrics(type, body) {
        if (!globalAppSettings.isUiLogEnabled) {
            return;
        }

        type = logTypes[type];

        if (type === logTypes.reviewWidgetAdding && $(selectors.pageReview).length > 0) {
            type = logTypes.reviewAdding;
        }
        var data = JSON.parse(globalAppSettings.statisticsTemplateMessage);
        data.t = type;
        data.body = body;
        var dataString = Base64.toBase64(JSON.stringify(data));

        var img = $('<img id="stat_' + new Date().getTime() + '" style="position: absolute; left: 0; top: 0;" width="1" height="1" src="' +
            new URL("?lb=" + dataString, globalAppSettings.statisticsHandlerUrl).href +
            '" />');
        img.on('error', () => { img.remove(); });
        img.on('load', () => { img.remove(); });
        $('head').append(img);
    }

    function sendScroll(baseMetricData) {
        if ($(selectors.pageContent)) {
            let scrollPercent;
            setInterval(() => {
                const newScrollPercent = getScrollPercent();
                if (newScrollPercent !== scrollPercent) {

                    var metricData = {
                        scrolledPercent: newScrollPercent,
                        location: window.location.href,
                        Title: document.title,
                        UniqueId: window.location.href
                    };

                    sendMetrics("scroll", Object.assign(baseMetricData, metricData));
                    scrollPercent = newScrollPercent;
                }
            }, 2000);
        }
    }

    function transitionLog(baseMetricData) {
        const link: any = document.activeElement;
        const currentLink: any = link.href != undefined ? link.href : "undefined";

        var metricData = {
            PreviousUrl: window.location.href,
            CurrentUrl: currentLink,
            Title: document.title,
            UniqueId: window.location.href
        };

        Metrics.sendMetrics("transition", Object.assign(baseMetricData, metricData));
    };

    // send scroll position from /faq/
    if ($(selectors.pageFaq).length > 0) {
        const name: string = "FAQ";
        sendScroll({ Name: name });
        window.addEventListener("beforeunload", () => { transitionLog({ Name: name }); });
    }

    // send scroll position from /reviews/
    if ($(selectors.pageReview).length > 0) {
        const name: string = "Reviews";

        var eventName = $(".review-article__header-event-name").data("event-name");
        sendScroll({ Name: name, EventName: eventName });
        window.addEventListener("beforeunload", () => { transitionLog({ Name: name, EventName: eventName }); });
    }

    // send scroll position from /news/
    if ($(selectors.pageNews).length > 0) {
        const name: string = "News";
        sendScroll({ Name: name });
        window.addEventListener("beforeunload", () => { transitionLog({ Name: name }); });
    }

    return {
        sendMetrics
    }
}());
